/**
 * @module sagas/DRM.js
 *
 * Sagas for handling DRM requests
 */
import { call, select } from 'redux-saga/effects';

import * as D from './deps';

const log = D.Logger.child({ component: 'sagas/DRM' });

/**
 * pings track's provided audioSkipUrl
 *
 * @param  {object} track - the track being skipped
 * @param  {string} [reason=DRMSkipReasons.UNKNOWN] - the skip reason
 */
export function* logSkipDRM(track, reason = D.Constants.Playback.DRMSkipReasons.UNKNOWN) {
  try {
    const audioSkipUrl = track?.get('audioSkipUrl');
    if (!audioSkipUrl) {
      log.error('logSkipDRM(): missing audioSkipUrl');
      return;
    }
    const currentPlaylist = yield select(D.getInDomain('playback.utils.getCurrentPlaylist'));
    const currentTrackTime = yield select(
      D.getInDomain('playback.utils.getPlaylistTrackTime'),
      currentPlaylist,
    );

    const secs = Math.floor(currentTrackTime);

    D.getInDomain('analytics.utils.pingTrackingUrl')(
      `${audioSkipUrl}&sec=${secs}&reason=${reason}&av=${__VERSION__}`,
    );
  } catch (err) {
    log.error(`logSkipDRM(): ${err}`);
  }
}

export function* logSkipDRMWatcher({ data }) {
  const { track, reason } = data;
  yield call(logSkipDRM, track, reason);
}

/**
 * ping track's provided audioReceiptUrl
 */
export function* logReceiptDRM() {
  const currentTrack = yield select(
    D.getInDomain('playback.utils.getCurrentAudioTrackFromActivePlaylist'),
  );
  const isAudioAd = yield select(D.getInDomain('ads.utils.isAudioAd', false), currentTrack);
  if (!currentTrack || isAudioAd) {
    return;
  }
  try {
    const audioReceiptUrl = currentTrack.get('audioReceiptURL');
    if (!audioReceiptUrl) {
      log.error('logReceiptDRM(): missing audioReceiptURL');
      return;
    }

    yield call(
      D.getInDomain('analytics.utils.pingTrackingUrl'),
      `${audioReceiptUrl}&av=${__VERSION__}`,
    );
  } catch (err) {
    log.error(`logReceiptDRM(): ${err}`);
  }
}

export function* onTrackInterrupted({ payload: { previousSourceId, previousTrack } }) {
  const wasPlayingAPS = yield select(D.PlaybackUtils.isPlaylistModelTypeAPSItem, previousSourceId);
  if (wasPlayingAPS) {
    return;
  }
  yield call(logSkipDRM, previousTrack, D.Constants.Playback.DRMSkipReasons.STATION_CHANGE);
}
